import React from 'react';
import { ListItemButton, styled, Typography } from '@mui/material';
import { Procedure } from 'types/procedure';

const ListItemStyled = styled(ListItemButton)({
  alignItems: 'center',
  gap: 10,
  justifyContent: 'flex-start',
  '& svg': {
    color: '#ccc',
  },
});

interface ProcedureItemProps {
  option: Procedure;
  selected: Procedure | null;
  handleSelect(procedure: Procedure): void;
}

const ProcedureItem: React.FC<ProcedureItemProps> = ({ option, selected, handleSelect }) => {
  return (
    <ListItemStyled disabled={selected?.id === option.id} onClick={() => handleSelect(option)}>
      <div>
        <Typography>
          #{option.id} - {option.name}
        </Typography>
      </div>
    </ListItemStyled>
  );
};

export default ProcedureItem;
